<template>
  <div class="page_404 error error-6 d-flex bgi-size-cover bgi-position-center" :style="{
        //backgroundImage: `url(${backgroundImage})`,
        //backgroundPosition: `center`,
        //backgroundSize: `cover`//
      }">
      <div class="container d-flex justify-content-center align-items-center">
        <div class="text_box">
          <h1>Oops...</h1>
          <h6>Page Not Found</h6>
          <p>Looks like something went wrong. We're working on it</p>
          <router-link to="/" class="btn submit-btn-fill-color">Back to Homepage</router-link>
        </div>
      </div>
    </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error-6.scss";
</style>

<script>
export default {
  name: "Error-6",
  mounted() {},
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/error/bg6.jpg";
    },
  },
};
</script>
<style scoped>
.page_404 .btn {
	color: #fff !important;
	min-width: 210px;
	width: auto;
  font-weight: 500;
}
.page_404 .btn:hover::before {
	opacity: .08;
}
.page_404{
height: 100vh;
padding: 50px 0;
background-color: #fff;
}
.page_404 .container {
  text-align: center;
}
.page_404 .text_box{
	background-color: #fff;
	max-width: 1000px;
	width: 100%;
	padding: 80px;
	margin: 0 auto;
	/* box-shadow: 0px 0px 42px 0px rgb(0 0 0 / 9%); */
}

.page_404 h1{
	font-weight: 800;
	font-size: 136px;
	margin-bottom: 16px;
	color: #ff6363;
}
.page_404 h6{
	font-size: 32px;
	font-weight: 700;
	margin-bottom: 20px;
}
.page_404 .text_boxp {
	font-size: 19px;
	margin-bottom: 22px;
}
.page_404 .text_box p {
	font-size: 18px;
}

@media (max-width: 991px){
  .page_404 h1 {
    font-size: 112px;
  }
  .page_404 h6 {
    font-size: 28px;
  }
}
@media (max-width: 767px){
  .page_404 .text_box {
    padding: 50px;
  }
  .page_404 h1 {
    font-size: 96px;
  }
  .page_404 .text_box p {
    max-width: 340px;
    margin: 0 auto 16px;
  }
}
@media (max-width: 575px){
  .page_404 .text_box{
    padding: 20px;
  }
  .page_404 h1 {
    font-size: 78px;
  }
  .page_404 h6 {
    font-size: 26px;
  }
  .page_404 .text_box p {
    font-size: 17px;
  }
}
</style>